import React, {useEffect, useRef, useState} from 'react';
import {FixedSizeList as List} from 'react-window';
import {sortInputFirst} from './utils';
const listHeight = 250;
const itemHeight = 25;
function MenuList(props) {
   const {options, children, getValue, focusedOption} = props;
   const [value] = getValue();
   const initialOffset = options.indexOf(value) * itemHeight;
   const listRef = useRef(null);
   let childrenToRender = props.children;

   return (
      <List
         ref={listRef}
         height={listHeight}
         itemCount={childrenToRender.length}
         itemSize={itemHeight}
         initialScrollOffset={initialOffset}
      >
         {({index, style}) => {
            return (
               <div tabIndex={index} style={{...style, textAlign: 'start'}}>
                  {childrenToRender[index]}
               </div>
            );
         }}
      </List>
   );
}

export default MenuList;
